module.exports = __webpack_public_path__ + "assets/img/00199.8d2480ce.png";